// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Event Detail Page ──────────────────────────────────────────────────────── */

.ed-loading,
.ed-not-found {
  text-align: center;
  padding: 4rem 1rem;
  color: #555;
  font-size: 1.1rem;
}

.ed-not-found h2 { margin-bottom: 1.5rem; color: #1a1a2e; }

/* ── Back buttons ── */
.ed-back-btn,
.ed-back-hero {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: color 0.15s;
  padding: 0;
}

.ed-back-btn {
  color: #00703C;
  margin-bottom: 1.5rem;
}
.ed-back-btn:hover { color: #005a30; text-decoration: underline; }

.ed-back-hero {
  position: absolute;
  top: 1rem;
  left: 1rem;
  color: #fff;
  background: rgba(0,0,0,0.45);
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 0.85rem;
  z-index: 2;
}
.ed-back-hero:hover { background: rgba(0,0,0,0.65); }

/* ── Hero image ── */
.ed-hero {
  position: relative;
  width: 100%;
  height: 340px;
  overflow: hidden;
  background: #f0f0f0;
}

.ed-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ed-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.4) 100%);
}

.ed-hero-badges {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ed-badge {
  font-size: 12px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
}
.ed-badge.green { background: #00703C; color: #fff; }
.ed-badge.gold  { background: #ffc107; color: #333; }
.ed-badge.grey  { background: rgba(255,255,255,0.25); color: #fff; backdrop-filter: blur(4px); }

/* ── Content area ── */
.ed-page {
  max-width: 780px;
  margin: 0 auto;
  padding-bottom: 4rem;
  font-family: Arial, sans-serif;
}

.ed-content {
  padding: 2rem 1.5rem;
}

/* ── Header ── */
.ed-header { margin-bottom: 2rem; }

.ed-title {
  font-size: 2rem;
  color: #1a1a2e;
  margin: 0 0 1rem;
  line-height: 1.25;
}

.ed-meta {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ed-meta-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
  color: #555;
}

.ed-sold-out { color: #dc3545; font-weight: bold; }

/* ── Description ── */
.ed-description {
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #eee;
}

.ed-description p {
  font-size: 1rem;
  color: #333;
  line-height: 1.8;
  margin: 0;
  white-space: pre-wrap;
}

/* ── Section headings ── */
.ed-section-heading {
  font-size: 1.2rem;
  color: #00703C;
  border-left: 4px solid #00703C;
  padding-left: 0.75rem;
  margin: 0 0 1.25rem;
}

/* ── Free event note ── */
.ed-free-note {
  background: #f0f7f0;
  border: 1px solid #c3e6cb;
  border-radius: 10px;
  padding: 1.25rem 1.5rem;
  font-size: 1rem;
  color: #155724;
  margin-bottom: 2rem;
}

/* ── Sold out box ── */
.ed-soldout-box {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 10px;
  padding: 1.25rem 1.5rem;
  color: #856404;
  margin-top: 2rem;
}

.ed-soldout-box strong { font-size: 1rem; display: block; margin-bottom: 4px; }
.ed-soldout-box p { margin: 0; font-size: 0.9rem; }

/* ── Ticket form wrapper ── */
.ed-ticket-form-wrapper {
  border-top: 1px solid #eee;
  padding-top: 2rem;
  margin-top: 2rem;
}

/* ── Package selector ── */
.ed-package-selector { margin-bottom: 1.5rem; }
.ed-package-title { font-size: 15px; font-weight: 700; color: #1a1a2e; margin: 0 0 0.25rem; }
.ed-package-sub   { font-size: 12px; color: #888; margin: 0 0 0.75rem; }

.ed-packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  margin-bottom: 0.75rem;
}

.ed-package-card {
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  padding: 0.85rem 0.75rem;
  text-align: center;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.ed-package-card:hover:not(:disabled) {
  border-color: #00703C;
  background: #f0f7f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,112,60,0.15);
}
.ed-package-card.selected { border-color: #00703C; background: #e8f5e9; }
.ed-package-card.sold-out { opacity: 0.5; cursor: not-allowed; background: #f5f5f5; }

.ed-pkg-name    { font-size: 16px; font-weight: 800; color: #1a1a2e; margin-bottom: 4px; }
.ed-pkg-size    { font-size: 12px; color: #666; margin-bottom: 6px; }
.ed-pkg-price   { font-size: 15px; font-weight: 700; color: #00703C; }
.ed-pkg-per     { font-size: 11px; color: #888; margin-top: 2px; }
.ed-pkg-desc    { font-size: 11px; color: #555; margin-top: 6px; font-style: italic; }
.ed-pkg-soldout { font-size: 11px; color: #dc3545; font-weight: bold; margin-top: 4px; }
.ed-pkg-tick    { position: absolute; top: 6px; right: 8px; font-size: 12px; color: #00703C; font-weight: bold; }

.ed-clear-pkg {
  background: none; border: none; color: #888;
  font-size: 12px; cursor: pointer; padding: 0;
  text-decoration: underline; margin-bottom: 0.5rem;
}
.ed-clear-pkg:hover { color: #dc3545; }

.ed-pkg-divider { text-align: center; color: #bbb; font-size: 12px; margin: 0.75rem 0 0.5rem; }

/* ── Pricing tiers ── */
.ed-pricing-tiers { background: #f8f9fa; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0.75rem 1rem; margin-bottom: 1.25rem; }
.ed-tiers-title   { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; display: flex; align-items: center; gap: 5px; }
.ed-tiers-grid    { display: flex; flex-direction: column; gap: 4px; }
.ed-tier-row      { display: flex; justify-content: space-between; align-items: center; font-size: 13px; padding: 4px 0; border-bottom: 1px solid #eee; color: #555; }
.ed-tier-row:last-child { border-bottom: none; }
.ed-tier-tag      { font-size: 11px; font-weight: bold; padding: 2px 8px; border-radius: 10px; background: #e0e0e0; color: #555; }
.ed-tier-tag.green { background: #d4edda; color: #155724; }
.ed-tier-tag.gold  { background: #fff3cd; color: #856404; }

/* ── Form ── */
.ed-form { display: flex; flex-direction: column; gap: 1rem; }

.ed-booker-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
}

.ed-sub-heading {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 0 0 0.75rem;
}

.ed-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}
.ed-form-row:last-child { margin-bottom: 0; }

.ed-field { display: flex; flex-direction: column; gap: 4px; }
.ed-field label { font-size: 13px; font-weight: 600; color: #444; }

.ed-field input,
.ed-field select {
  padding: 0.65rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border 0.2s;
  box-sizing: border-box;
  width: 100%;
}
.ed-field input:focus,
.ed-field select:focus { border-color: #00703C; }
.ed-field input.error,
.ed-field select.error { border-color: #dc3545; }

.ed-err { font-size: 12px; color: #dc3545; }

/* ── Quantity ── */
.ed-qty-section { display: flex; flex-direction: column; gap: 0.5rem; }

.ed-qty-row {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  width: fit-content;
}

.ed-qty-btn {
  width: 42px; height: 42px;
  background: #f0f0f0; border: none;
  font-size: 22px; cursor: pointer; color: #333;
  transition: background 0.2s;
  display: flex; align-items: center; justify-content: center;
}
.ed-qty-btn:hover { background: #ddd; }

.ed-qty-input {
  width: 60px; height: 42px;
  text-align: center;
  border: none;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  font-size: 16px; outline: none;
}

.ed-price-summary { width: 100%; }

.ed-discount-badge {
  background: #d4edda; color: #155724;
  border-radius: 6px; padding: 6px 10px;
  font-size: 13px; font-weight: 600;
  margin-bottom: 0.5rem; text-align: center;
}

.ed-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
}
.ed-total-row strong { color: #00703C; font-size: 1.3rem; }

.ed-selected-banner {
  background: #e8f5e9; border: 1px solid #00703C;
  border-radius: 8px; padding: 10px 14px;
  font-size: 14px; color: #1a1a2e;
}

/* ── Attendees ── */
.ed-attendees { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; }
.ed-attendees-title { font-size: 14px; font-weight: 600; color: #333; margin: 0; padding: 0.75rem 1rem; background: #f0f7f0; border-bottom: 1px solid #e0e0e0; }
.ed-attendee-note { font-size: 12px; color: #888; font-style: italic; padding: 0 1rem 0.5rem; margin: 0; background: #f0f7f0; }
.ed-attendee-row { display: flex; gap: 0.75rem; padding: 0.75rem 1rem; border-bottom: 1px solid #f0f0f0; align-items: flex-start; }
.ed-attendee-row:last-child { border-bottom: none; }
.ed-attendee-num { font-size: 13px; font-weight: bold; color: #00703C; min-width: 30px; padding-top: 28px; }
.ed-attendee-fields { flex: 1 1; display: flex; flex-direction: column; gap: 8px; }

/* ── Card ── */
.ed-card-wrapper {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
  transition: border 0.2s;
}
.ed-card-wrapper:focus-within { border-color: #00703C; }

.ed-secure-note { font-size: 12px; color: #777; text-align: center; margin: 0; }

.ed-pay-btn {
  width: 100%; padding: 0.85rem;
  background: #00703C; color: #fff;
  border: none; border-radius: 8px;
  font-size: 16px; font-weight: bold;
  cursor: pointer; transition: background 0.2s;
}
.ed-pay-btn:hover:not(:disabled) { background: #005a30; }
.ed-pay-btn:disabled { background: #ccc; cursor: not-allowed; }

/* ── Success ── */
.ed-success { text-align: center; padding: 2rem 0; }
.ed-success h2 { font-size: 1.6rem; color: #1a1a2e; margin-bottom: 0.5rem; }

.ed-success-details {
  background: #f0f7f0; border-radius: 10px;
  padding: 1rem 1.2rem; margin: 1.2rem 0; text-align: left;
}
.ed-success-details div {
  display: flex; justify-content: space-between;
  padding: 0.4rem 0; border-bottom: 1px solid #ddd; font-size: 0.95rem;
}
.ed-success-details div:last-child { border-bottom: none; }
.ed-success-details span   { color: #666; }
.ed-success-details strong { color: #1a1a2e; }

.ed-ref {
  background: #00703C; color: #fff !important;
  padding: 2px 10px; border-radius: 4px;
  font-family: monospace; font-size: 0.9rem;
}

.ed-attendees-summary { background: #f8f9fa; border-radius: 8px; padding: 0.75rem 1rem; margin: 0.75rem 0; text-align: left; }
.ed-attendees-summary-title { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; }
.ed-attendee-summary-row { display: flex; justify-content: space-between; font-size: 13px; color: #555; padding: 3px 0; border-bottom: 1px solid #eee; }
.ed-attendee-summary-row:last-child { border-bottom: none; }

.ed-email-note { font-size: 0.85rem; color: #555; margin-bottom: 1.2rem; }

.ed-done-btn {
  padding: 0.75rem 2.5rem;
  background: #00703C; color: #fff;
  border: none; border-radius: 8px;
  font-size: 15px; font-weight: bold; cursor: pointer;
}
.ed-done-btn:hover { background: #005a30; }

/* ── Responsive ── */
@media (max-width: 600px) {
  .ed-hero   { height: 220px; }
  .ed-title  { font-size: 1.5rem; }
  .ed-content { padding: 1.25rem 1rem; }
  .ed-form-row { grid-template-columns: 1fr; }
}

/* ── Buy Ticket CTA (shown before form opens) ── */
.ed-buy-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: #f0f7f0;
  border: 2px solid #00703C;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.ed-buy-cta-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1rem;
  color: #333;
}

.ed-cta-remaining {
  color: #888;
  font-size: 0.9rem;
  font-weight: normal;
}

.ed-buy-btn {
  padding: 0.8rem 2.5rem;
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}
.ed-buy-btn:hover { background: #005a30; }

@media (max-width: 500px) {
  .ed-buy-cta { flex-direction: column; align-items: flex-start; }
  .ed-buy-btn { width: 100%; text-align: center; }
}
/* ── CTA action row (Buy + Share buttons) ── */
.ed-cta-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

/* ── Share / Copy Ticket Link button ── */
.ed-share-btn {
  padding: 0.75rem 1.25rem;
  background: transparent;
  color: #555;
  border: 1.5px dashed #bbb;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
  white-space: nowrap;
}
.ed-share-btn:hover {
  border-color: #00703C;
  color: #00703C;
}

@media (max-width: 500px) {
  .ed-cta-actions { flex-direction: column; width: 100%; }
  .ed-share-btn   { width: 100%; text-align: center; }
}

/* ── Events listing page share button ── */
.event-card-actions {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.75rem;
}

.event-share-btn {
  display: block;
  width: 100%;
  background: transparent;
  color: #666;
  border: 1px dashed #bbb;
  border-radius: 8px;
  padding: 0.4rem 0.75rem;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
  text-align: center;
}
.event-share-btn:hover {
  border-color: #00703C;
  color: #00703C;
}`, "",{"version":3,"sources":["webpack://./src/pages/EventDetail.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,mBAAmB,qBAAqB,EAAE,cAAc,EAAE;;AAE1D,uBAAuB;AACvB;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA,qBAAqB,cAAc,EAAE,0BAA0B,EAAE;;AAEjE;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA,sBAAsB,4BAA4B,EAAE;;AAEpD,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;AACpD,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;AACpD,kBAAkB,kCAAkC,EAAE,WAAW,EAAE,0BAA0B,EAAE;;AAE/F,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB,aAAa,mBAAmB,EAAE;;AAElC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA,eAAe,cAAc,EAAE,iBAAiB,EAAE;;AAElD,sBAAsB;AACtB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC9E,oBAAoB,SAAS,EAAE,iBAAiB,EAAE;;AAElD,8BAA8B;AAC9B;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B,uBAAuB,qBAAqB,EAAE;AAC9C,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC5F,oBAAoB,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEvE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,4BAA4B,qBAAqB,EAAE,mBAAmB,EAAE;AACxE,4BAA4B,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;;AAEpF,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACzF,kBAAkB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACpE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,kBAAkB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;AACjE,kBAAkB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACrF,kBAAkB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACvF,kBAAkB,kBAAkB,EAAE,QAAQ,EAAE,UAAU,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEhH;EACE,gBAAgB,EAAE,YAAY,EAAE,WAAW;EAC3C,eAAe,EAAE,eAAe,EAAE,UAAU;EAC5C,0BAA0B,EAAE,qBAAqB;AACnD;AACA,sBAAsB,cAAc,EAAE;;AAEtC,kBAAkB,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE,wBAAwB,EAAE;;AAE9F,wBAAwB;AACxB,oBAAoB,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,sBAAsB,EAAE;AACvI,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtI,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,oBAAoB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE,6BAA6B,EAAE,WAAW,EAAE;AACrK,0BAA0B,mBAAmB,EAAE;AAC/C,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,WAAW,EAAE;AACjI,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,eAAe;AACf,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE7D;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,0BAA0B,gBAAgB,EAAE;;AAE5C,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7D,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAElE;;EAEE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;AACA;yBACyB,qBAAqB,EAAE;AAChD;yBACyB,qBAAqB,EAAE;;AAEhD,UAAU,eAAe,EAAE,cAAc,EAAE;;AAE3C,mBAAmB;AACnB,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAEtE;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB,EAAE,YAAY;EACjC,eAAe,EAAE,eAAe,EAAE,WAAW;EAC7C,2BAA2B;EAC3B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,oBAAoB,gBAAgB,EAAE;;AAEtC;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe,EAAE,aAAa;AAChC;;AAEA,oBAAoB,WAAW,EAAE;;AAEjC;EACE,mBAAmB,EAAE,cAAc;EACnC,kBAAkB,EAAE,iBAAiB;EACrC,eAAe,EAAE,gBAAgB;EACjC,qBAAqB,EAAE,kBAAkB;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;AACA,uBAAuB,cAAc,EAAE,iBAAiB,EAAE;;AAE1D;EACE,mBAAmB,EAAE,yBAAyB;EAC9C,kBAAkB,EAAE,kBAAkB;EACtC,eAAe,EAAE,cAAc;AACjC;;AAEA,oBAAoB;AACpB,gBAAgB,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACjF,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AAC/J,oBAAoB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC9H,mBAAmB,aAAa,EAAE,YAAY,EAAE,qBAAqB,EAAE,gCAAgC,EAAE,uBAAuB,EAAE;AAClI,8BAA8B,mBAAmB,EAAE;AACnD,mBAAmB,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC3G,sBAAsB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEhF,eAAe;AACf;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,gCAAgC,qBAAqB,EAAE;;AAEvD,kBAAkB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE;;AAE/E;EACE,WAAW,EAAE,gBAAgB;EAC7B,mBAAmB,EAAE,WAAW;EAChC,YAAY,EAAE,kBAAkB;EAChC,eAAe,EAAE,iBAAiB;EAClC,eAAe,EAAE,2BAA2B;AAC9C;AACA,mCAAmC,mBAAmB,EAAE;AACxD,uBAAuB,gBAAgB,EAAE,mBAAmB,EAAE;;AAE9D,kBAAkB;AAClB,cAAc,kBAAkB,EAAE,eAAe,EAAE;AACnD,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE3E;EACE,mBAAmB,EAAE,mBAAmB;EACxC,oBAAoB,EAAE,gBAAgB,EAAE,gBAAgB;AAC1D;AACA;EACE,aAAa,EAAE,8BAA8B;EAC7C,iBAAiB,EAAE,6BAA6B,EAAE,kBAAkB;AACtE;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,6BAA6B,WAAW,EAAE;AAC1C,6BAA6B,cAAc,EAAE;;AAE7C;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,iBAAiB,EAAE,kBAAkB;EACrC,sBAAsB,EAAE,iBAAiB;AAC3C;;AAEA,wBAAwB,mBAAmB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7H,8BAA8B,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAClG,2BAA2B,aAAa,EAAE,8BAA8B,EAAE,eAAe,EAAE,WAAW,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACvJ,sCAAsC,mBAAmB,EAAE;;AAE3D,iBAAiB,kBAAkB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAEzE;EACE,uBAAuB;EACvB,mBAAmB,EAAE,WAAW;EAChC,YAAY,EAAE,kBAAkB;EAChC,eAAe,EAAE,iBAAiB,EAAE,eAAe;AACrD;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C,qBAAqB;AACrB;EACE,aAAa,aAAa,EAAE;EAC5B,aAAa,iBAAiB,EAAE;EAChC,cAAc,qBAAqB,EAAE;EACrC,eAAe,0BAA0B,EAAE;AAC7C;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,cAAc,sBAAsB,EAAE,uBAAuB,EAAE;EAC/D,cAAc,WAAW,EAAE,kBAAkB,EAAE;AACjD;AACA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB,sBAAsB,EAAE,WAAW,EAAE;EACvD,kBAAkB,WAAW,EAAE,kBAAkB,EAAE;AACrD;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* ── Event Detail Page ──────────────────────────────────────────────────────── */\n\n.ed-loading,\n.ed-not-found {\n  text-align: center;\n  padding: 4rem 1rem;\n  color: #555;\n  font-size: 1.1rem;\n}\n\n.ed-not-found h2 { margin-bottom: 1.5rem; color: #1a1a2e; }\n\n/* ── Back buttons ── */\n.ed-back-btn,\n.ed-back-hero {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: color 0.15s;\n  padding: 0;\n}\n\n.ed-back-btn {\n  color: #00703C;\n  margin-bottom: 1.5rem;\n}\n.ed-back-btn:hover { color: #005a30; text-decoration: underline; }\n\n.ed-back-hero {\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  color: #fff;\n  background: rgba(0,0,0,0.45);\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 0.85rem;\n  z-index: 2;\n}\n.ed-back-hero:hover { background: rgba(0,0,0,0.65); }\n\n/* ── Hero image ── */\n.ed-hero {\n  position: relative;\n  width: 100%;\n  height: 340px;\n  overflow: hidden;\n  background: #f0f0f0;\n}\n\n.ed-hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ed-hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.4) 100%);\n}\n\n.ed-hero-badges {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.ed-badge {\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n.ed-badge.green { background: #00703C; color: #fff; }\n.ed-badge.gold  { background: #ffc107; color: #333; }\n.ed-badge.grey  { background: rgba(255,255,255,0.25); color: #fff; backdrop-filter: blur(4px); }\n\n/* ── Content area ── */\n.ed-page {\n  max-width: 780px;\n  margin: 0 auto;\n  padding-bottom: 4rem;\n  font-family: Arial, sans-serif;\n}\n\n.ed-content {\n  padding: 2rem 1.5rem;\n}\n\n/* ── Header ── */\n.ed-header { margin-bottom: 2rem; }\n\n.ed-title {\n  font-size: 2rem;\n  color: #1a1a2e;\n  margin: 0 0 1rem;\n  line-height: 1.25;\n}\n\n.ed-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ed-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.95rem;\n  color: #555;\n}\n\n.ed-sold-out { color: #dc3545; font-weight: bold; }\n\n/* ── Description ── */\n.ed-description {\n  margin-bottom: 2.5rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #eee;\n}\n\n.ed-description p {\n  font-size: 1rem;\n  color: #333;\n  line-height: 1.8;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* ── Section headings ── */\n.ed-section-heading {\n  font-size: 1.2rem;\n  color: #00703C;\n  border-left: 4px solid #00703C;\n  padding-left: 0.75rem;\n  margin: 0 0 1.25rem;\n}\n\n/* ── Free event note ── */\n.ed-free-note {\n  background: #f0f7f0;\n  border: 1px solid #c3e6cb;\n  border-radius: 10px;\n  padding: 1.25rem 1.5rem;\n  font-size: 1rem;\n  color: #155724;\n  margin-bottom: 2rem;\n}\n\n/* ── Sold out box ── */\n.ed-soldout-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 10px;\n  padding: 1.25rem 1.5rem;\n  color: #856404;\n  margin-top: 2rem;\n}\n\n.ed-soldout-box strong { font-size: 1rem; display: block; margin-bottom: 4px; }\n.ed-soldout-box p { margin: 0; font-size: 0.9rem; }\n\n/* ── Ticket form wrapper ── */\n.ed-ticket-form-wrapper {\n  border-top: 1px solid #eee;\n  padding-top: 2rem;\n  margin-top: 2rem;\n}\n\n/* ── Package selector ── */\n.ed-package-selector { margin-bottom: 1.5rem; }\n.ed-package-title { font-size: 15px; font-weight: 700; color: #1a1a2e; margin: 0 0 0.25rem; }\n.ed-package-sub   { font-size: 12px; color: #888; margin: 0 0 0.75rem; }\n\n.ed-packages-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 10px;\n  margin-bottom: 0.75rem;\n}\n\n.ed-package-card {\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 0.85rem 0.75rem;\n  text-align: center;\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n.ed-package-card:hover:not(:disabled) {\n  border-color: #00703C;\n  background: #f0f7f0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,112,60,0.15);\n}\n.ed-package-card.selected { border-color: #00703C; background: #e8f5e9; }\n.ed-package-card.sold-out { opacity: 0.5; cursor: not-allowed; background: #f5f5f5; }\n\n.ed-pkg-name    { font-size: 16px; font-weight: 800; color: #1a1a2e; margin-bottom: 4px; }\n.ed-pkg-size    { font-size: 12px; color: #666; margin-bottom: 6px; }\n.ed-pkg-price   { font-size: 15px; font-weight: 700; color: #00703C; }\n.ed-pkg-per     { font-size: 11px; color: #888; margin-top: 2px; }\n.ed-pkg-desc    { font-size: 11px; color: #555; margin-top: 6px; font-style: italic; }\n.ed-pkg-soldout { font-size: 11px; color: #dc3545; font-weight: bold; margin-top: 4px; }\n.ed-pkg-tick    { position: absolute; top: 6px; right: 8px; font-size: 12px; color: #00703C; font-weight: bold; }\n\n.ed-clear-pkg {\n  background: none; border: none; color: #888;\n  font-size: 12px; cursor: pointer; padding: 0;\n  text-decoration: underline; margin-bottom: 0.5rem;\n}\n.ed-clear-pkg:hover { color: #dc3545; }\n\n.ed-pkg-divider { text-align: center; color: #bbb; font-size: 12px; margin: 0.75rem 0 0.5rem; }\n\n/* ── Pricing tiers ── */\n.ed-pricing-tiers { background: #f8f9fa; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0.75rem 1rem; margin-bottom: 1.25rem; }\n.ed-tiers-title   { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; display: flex; align-items: center; gap: 5px; }\n.ed-tiers-grid    { display: flex; flex-direction: column; gap: 4px; }\n.ed-tier-row      { display: flex; justify-content: space-between; align-items: center; font-size: 13px; padding: 4px 0; border-bottom: 1px solid #eee; color: #555; }\n.ed-tier-row:last-child { border-bottom: none; }\n.ed-tier-tag      { font-size: 11px; font-weight: bold; padding: 2px 8px; border-radius: 10px; background: #e0e0e0; color: #555; }\n.ed-tier-tag.green { background: #d4edda; color: #155724; }\n.ed-tier-tag.gold  { background: #fff3cd; color: #856404; }\n\n/* ── Form ── */\n.ed-form { display: flex; flex-direction: column; gap: 1rem; }\n\n.ed-booker-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.ed-sub-heading {\n  font-size: 14px;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 0.75rem;\n}\n\n.ed-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.ed-form-row:last-child { margin-bottom: 0; }\n\n.ed-field { display: flex; flex-direction: column; gap: 4px; }\n.ed-field label { font-size: 13px; font-weight: 600; color: #444; }\n\n.ed-field input,\n.ed-field select {\n  padding: 0.65rem 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 15px;\n  outline: none;\n  transition: border 0.2s;\n  box-sizing: border-box;\n  width: 100%;\n}\n.ed-field input:focus,\n.ed-field select:focus { border-color: #00703C; }\n.ed-field input.error,\n.ed-field select.error { border-color: #dc3545; }\n\n.ed-err { font-size: 12px; color: #dc3545; }\n\n/* ── Quantity ── */\n.ed-qty-section { display: flex; flex-direction: column; gap: 0.5rem; }\n\n.ed-qty-row {\n  display: flex;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  width: fit-content;\n}\n\n.ed-qty-btn {\n  width: 42px; height: 42px;\n  background: #f0f0f0; border: none;\n  font-size: 22px; cursor: pointer; color: #333;\n  transition: background 0.2s;\n  display: flex; align-items: center; justify-content: center;\n}\n.ed-qty-btn:hover { background: #ddd; }\n\n.ed-qty-input {\n  width: 60px; height: 42px;\n  text-align: center;\n  border: none;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  font-size: 16px; outline: none;\n}\n\n.ed-price-summary { width: 100%; }\n\n.ed-discount-badge {\n  background: #d4edda; color: #155724;\n  border-radius: 6px; padding: 6px 10px;\n  font-size: 13px; font-weight: 600;\n  margin-bottom: 0.5rem; text-align: center;\n}\n\n.ed-total-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f8f8;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 1.1rem;\n}\n.ed-total-row strong { color: #00703C; font-size: 1.3rem; }\n\n.ed-selected-banner {\n  background: #e8f5e9; border: 1px solid #00703C;\n  border-radius: 8px; padding: 10px 14px;\n  font-size: 14px; color: #1a1a2e;\n}\n\n/* ── Attendees ── */\n.ed-attendees { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; }\n.ed-attendees-title { font-size: 14px; font-weight: 600; color: #333; margin: 0; padding: 0.75rem 1rem; background: #f0f7f0; border-bottom: 1px solid #e0e0e0; }\n.ed-attendee-note { font-size: 12px; color: #888; font-style: italic; padding: 0 1rem 0.5rem; margin: 0; background: #f0f7f0; }\n.ed-attendee-row { display: flex; gap: 0.75rem; padding: 0.75rem 1rem; border-bottom: 1px solid #f0f0f0; align-items: flex-start; }\n.ed-attendee-row:last-child { border-bottom: none; }\n.ed-attendee-num { font-size: 13px; font-weight: bold; color: #00703C; min-width: 30px; padding-top: 28px; }\n.ed-attendee-fields { flex: 1; display: flex; flex-direction: column; gap: 8px; }\n\n/* ── Card ── */\n.ed-card-wrapper {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 12px 14px;\n  background: #fff;\n  transition: border 0.2s;\n}\n.ed-card-wrapper:focus-within { border-color: #00703C; }\n\n.ed-secure-note { font-size: 12px; color: #777; text-align: center; margin: 0; }\n\n.ed-pay-btn {\n  width: 100%; padding: 0.85rem;\n  background: #00703C; color: #fff;\n  border: none; border-radius: 8px;\n  font-size: 16px; font-weight: bold;\n  cursor: pointer; transition: background 0.2s;\n}\n.ed-pay-btn:hover:not(:disabled) { background: #005a30; }\n.ed-pay-btn:disabled { background: #ccc; cursor: not-allowed; }\n\n/* ── Success ── */\n.ed-success { text-align: center; padding: 2rem 0; }\n.ed-success h2 { font-size: 1.6rem; color: #1a1a2e; margin-bottom: 0.5rem; }\n\n.ed-success-details {\n  background: #f0f7f0; border-radius: 10px;\n  padding: 1rem 1.2rem; margin: 1.2rem 0; text-align: left;\n}\n.ed-success-details div {\n  display: flex; justify-content: space-between;\n  padding: 0.4rem 0; border-bottom: 1px solid #ddd; font-size: 0.95rem;\n}\n.ed-success-details div:last-child { border-bottom: none; }\n.ed-success-details span   { color: #666; }\n.ed-success-details strong { color: #1a1a2e; }\n\n.ed-ref {\n  background: #00703C; color: #fff !important;\n  padding: 2px 10px; border-radius: 4px;\n  font-family: monospace; font-size: 0.9rem;\n}\n\n.ed-attendees-summary { background: #f8f9fa; border-radius: 8px; padding: 0.75rem 1rem; margin: 0.75rem 0; text-align: left; }\n.ed-attendees-summary-title { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; }\n.ed-attendee-summary-row { display: flex; justify-content: space-between; font-size: 13px; color: #555; padding: 3px 0; border-bottom: 1px solid #eee; }\n.ed-attendee-summary-row:last-child { border-bottom: none; }\n\n.ed-email-note { font-size: 0.85rem; color: #555; margin-bottom: 1.2rem; }\n\n.ed-done-btn {\n  padding: 0.75rem 2.5rem;\n  background: #00703C; color: #fff;\n  border: none; border-radius: 8px;\n  font-size: 15px; font-weight: bold; cursor: pointer;\n}\n.ed-done-btn:hover { background: #005a30; }\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .ed-hero   { height: 220px; }\n  .ed-title  { font-size: 1.5rem; }\n  .ed-content { padding: 1.25rem 1rem; }\n  .ed-form-row { grid-template-columns: 1fr; }\n}\n\n/* ── Buy Ticket CTA (shown before form opens) ── */\n.ed-buy-cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  background: #f0f7f0;\n  border: 2px solid #00703C;\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  margin-top: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.ed-buy-cta-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1rem;\n  color: #333;\n}\n\n.ed-cta-remaining {\n  color: #888;\n  font-size: 0.9rem;\n  font-weight: normal;\n}\n\n.ed-buy-btn {\n  padding: 0.8rem 2.5rem;\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n.ed-buy-btn:hover { background: #005a30; }\n\n@media (max-width: 500px) {\n  .ed-buy-cta { flex-direction: column; align-items: flex-start; }\n  .ed-buy-btn { width: 100%; text-align: center; }\n}\n/* ── CTA action row (Buy + Share buttons) ── */\n.ed-cta-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n/* ── Share / Copy Ticket Link button ── */\n.ed-share-btn {\n  padding: 0.75rem 1.25rem;\n  background: transparent;\n  color: #555;\n  border: 1.5px dashed #bbb;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s;\n  white-space: nowrap;\n}\n.ed-share-btn:hover {\n  border-color: #00703C;\n  color: #00703C;\n}\n\n@media (max-width: 500px) {\n  .ed-cta-actions { flex-direction: column; width: 100%; }\n  .ed-share-btn   { width: 100%; text-align: center; }\n}\n\n/* ── Events listing page share button ── */\n.event-card-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.75rem;\n}\n\n.event-share-btn {\n  display: block;\n  width: 100%;\n  background: transparent;\n  color: #666;\n  border: 1px dashed #bbb;\n  border-radius: 8px;\n  padding: 0.4rem 0.75rem;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s;\n  text-align: center;\n}\n.event-share-btn:hover {\n  border-color: #00703C;\n  color: #00703C;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
